module.exports = __webpack_public_path__ + "static/avatar-21bb0cfbc32d111cee7f737ad3c46ab6.png";